import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router'
import { LogoBlock } from '../components/LogoBlock'
import { Slider } from '../components/Slider'
import {
  OnboardingSlide1,
  OnboardingSlide2,
  OnboardingSlide3,
} from '../components/Onboarding.slides'
import { colors } from '../styles/colors'
import { useAppContext } from '../contexts/App.context'
import { createLanguageName } from '../functions/createLanguageName'
import { languagePagePath } from './LanguagePage'
import { useOnboardingContext } from '../contexts/OnboardingContext'
import { Typography } from '../ui/Typography'

export const OnboardingPage: FC = () => {
  const navigate = useNavigate()
  const { language } = useAppContext()

  const { completeOnboarding } = useOnboardingContext()

  const handleSkip = () => {
    completeOnboarding()
  }

  const handleLanguageChange = () => {
    navigate(languagePagePath)
  }

  return (
    <OnboardingContainer>
      <Header>
        <p />
        <LogoBlock />

        <LanguageButton onClick={handleLanguageChange}>
          <Typography fontSize={14} fontWeight={500} font="roboto">
            {createLanguageName(language)}
          </Typography>
        </LanguageButton>
      </Header>

      <Slider
        slides={[
          <OnboardingSlide1 key="slide1" />,
          <OnboardingSlide2 key="slide2" />,
          <OnboardingSlide3 key="slide3" />,
        ]}
      />

      <SkipButton onClick={handleSkip}>
        <Typography fontSize={14} fontWeight={700} font="roboto">
          <FormattedMessage id="onboarding.skip" defaultMessage="Пропустить" />
        </Typography>
      </SkipButton>
    </OnboardingContainer>
  )
}

export const onboardingPagePath = '/onboarding'

const OnboardingContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 48px;
`

const Header = styled.header`
  display: grid;
  grid-template-columns: 60px auto 60px;
  justify-items: center;
  padding: 16px 20px;
  position: relative;
  z-index: 10;

  @media (max-width: 400px) {
    grid-template-columns: 5px auto 60px;
  }
`

const LanguageButton = styled.button`
  padding: 8px 16px;
  border: 1px solid ${colors.grey200};
  border-radius: 20px;
  background: ${colors.white};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${colors.secondary};
    color: ${colors.secondary};
  }
`

const SkipButton = styled.button`
  width: max-content;
  border-radius: 100px;
  padding: 10px 16px;
  border: 1px solid ${colors.secondary};
  background: ${colors.white};
  color: ${colors.secondary};
  cursor: pointer;
  transition: all 0.2s;
  align-self: center;
`
